import { Box, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import { Link } from '@backstage/core-components';
import { useEffect, useRef, useState } from 'react';
import { useRouteRef } from '@backstage/core-plugin-api';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import { useLocation } from 'react-router-dom';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useUserLastReadEvent } from '../hooks/useUserLastReadEvent';
import { useSubmitReadEvent } from '../hooks/useSubmitReadEvent';
import { createTechdocsReaderPageRef } from '../routes';

export const RecentPageHeader = () => {
  const [showHeader, setShowHeader] = useState(true);
  const { entityRef } = useTechDocsReaderPage();
  const docEntityRef = stringifyEntityRef(entityRef);
  const location = useLocation();
  const initialPath = useRef(location.pathname);

  const entityPath = `/docs/${entityRef.namespace}/${entityRef.kind}/${entityRef.name}`;
  let page = location.pathname.startsWith(entityPath)
    ? location.pathname.slice(entityPath.length)
    : undefined;
  if (page?.endsWith('/')) {
    page = page.slice(0, -1);
  }
  if (page?.startsWith('/')) {
    page = page.slice(1);
  }

  useEffect(() => {
    if (location.pathname !== initialPath.current) {
      setShowHeader(false);
    }
  }, [location.pathname, initialPath]);

  const docRootRoute = useRouteRef(createTechdocsReaderPageRef)(entityRef);

  const { value: lastReadEvent, loading } = useUserLastReadEvent(
    docEntityRef,
    [],
  );
  const lastPageLink = lastReadEvent?.page
    ? `${docRootRoute}/${lastReadEvent.page}`
    : undefined;

  const submitReadEvent = useSubmitReadEvent();

  useEffect(() => {
    if (!loading && page !== undefined) {
      submitReadEvent(docEntityRef, page);
    }
  }, [loading, page, docEntityRef, submitReadEvent]);

  return (
    showHeader &&
    lastReadEvent &&
    lastReadEvent.page !== page &&
    lastPageLink && (
      <Box width="100%">
        <Alert
          severity="info"
          action={
            <IconButton>
              <CloseIcon
                fontSize="small"
                onClick={() => setShowHeader(false)}
              />
            </IconButton>
          }
        >
          Continue where you left off:{' '}
          <Link to={lastPageLink}>{lastReadEvent.page || 'Home'}</Link>{' '}
        </Alert>
      </Box>
    )
  );
};
